import { PlatformEnv } from '@evc/platform';

export type AppEnv = {
  PROTECTED_URIS: Record<string, string> & {
    DEMOAPP: string,
  };
} & PlatformEnv

export type BaseAppEnv = Omit<AppEnv, 'AUTH_CLIENT_ID' | 'PROTECTED_URIS' | 'ENV'>;

export const baseEnvironment: BaseAppEnv = {
  APP_NAME: 'demo-app',
  PORT: 3000,
  USE_CONNECT_PLATFORM: true,
  AUTH_FORCE_ORGANIZATION: true,
  AUTH_FORCE_LICENSE: true,
};
